import { postAPI } from '@/services-ts/axios'
import { PostFilter } from '@/types/Enums'
import type { IPayloadPostFilter } from '@/types/Request/PostAPI'
import type { IPostFilterStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const usePostFilterStore = defineStore('postFilter', {
  state: (): IPostFilterStore => ({
    postFilterList: {
      data: null,
      total: 0,
    },
  }),

  actions: {
    async GetPostFilterList() {
      const { status, data, total } = await postAPI.PostFilterServices.GetPostFilterList()

      if (status && data) {
        this.postFilterList.data = data
        this.postFilterList.total = total || 0
      } else {
        this.postFilterList = { data: null, total: 0 }
      }
    },

    async CreatePostFilter(payload: IPayloadPostFilter) {
      const { status, data } = await postAPI.PostFilterServices.CreatePostFilter(payload)
      if (status && data) {
        if (payload.key !== PostFilter.SENDER) {
          this.postFilterList.data?.postFilters.push(data)
        }
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        return true
      }
      return false
    },

    async UpdatePostFilter(payload: IPayloadPostFilter) {
      const { status, data, message } = await postAPI.PostFilterServices.UpdatePostFilter(payload)

      if (status) {
        const index = this.postFilterList.data?.postFilters.findIndex(
          item => item.id === payload.id,
        )

        if (index !== undefined && index !== -1) {
          this.postFilterList.data?.postFilters.splice(index, 1, data)
          void Alert({ message: Format('admin_global_success'), type: 'success' })
        } else {
          void Alert({ message: message || Format('admin_global_error'), type: 'danger' })
        }
      }

      return status
    },

    async DeletePostFilter(id: string) {
      const { status } = await postAPI.PostFilterServices.DeletePostFilter(id)

      if (status) {
        if (this.postFilterList.data?.postFilters) {
          this.postFilterList.data.postFilters = this.postFilterList.data.postFilters.filter(
            item => item.id !== id,
          )
        }
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
    },
  },
})
